(() => {
  'use strict';

  const termsPolicyPath = '/policies/terms-of-service';

  function normalizeTermsPolicyLinks(root = document) {
    const anchors = [];

    if (root.matches?.(`a[href$="${termsPolicyPath}"]`)) anchors.push(root);
    root.querySelectorAll?.(`a[href$="${termsPolicyPath}"]`).forEach((anchor) => anchors.push(anchor));

    anchors.forEach((anchor) => anchor.setAttribute('href', '/pages/regulamin'));
  }

  function normalizeHref(anchor) {
    const href = anchor.getAttribute('href') || '';
    if (!href || href === '#') return;

    if (href === '#ticho-shop-by-room') {
      anchor.addEventListener('click', (event) => {
        const target = document.getElementById('ticho-shop-by-room');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#ticho-shop-by-room');
      });
    }
  }

  function init() {
    document.querySelectorAll('body.template-index a[href]').forEach(normalizeHref);
    normalizeTermsPolicyLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => normalizeTermsPolicyLinks(node));
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
